import { JsonProperty } from "../../../models/utilities/json-property";
import { ShipmentType } from "../enums/_index";
import { ShipmentCreate } from "../shipments/shipment-create";

export class TruckCreate extends ShipmentCreate {

    public driverId : number|undefined = undefined;
    
    public tractorId : number|undefined = undefined;
    
    public trailerId : number|undefined = undefined;

    @JsonProperty({ toType : 'datetime-specific' })
    public returnTimeLocal : Date|undefined = undefined;

    public totalDistance : number|null = null;

    public totalTravelTime : string|null = null;

    constructor() {
        super();
        this.type = ShipmentType.Truck;
    }

}
